import { createFileRoute } from '@tanstack/react-router'

import { buildPageTitle } from '@/shared/lib/page-title'
import { JourneysListPage } from '@/features/journeys'

export const Route = createFileRoute('/_authenticated/_main/jornadas')({
  head: () => ({
    meta: [{ title: buildPageTitle('Jornadas') }]
  }),
  component: JourneysListPage
})
